module.exports = __webpack_public_path__ + "648615c139983249acd22a64aa83756e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/history/fi-2003.png
// module id = 425
// module chunks = 0